import React from 'react';
import { DataForDesignDrawingsManifold } from '../../designs/data-for-design-drawings/dataForDesignDrawingsResponse';
import { RoomRow } from './templates/RoomRow';

type Props = {
  manifold: DataForDesignDrawingsManifold;
};
export const RoomNameRow = ({ manifold }: Props) => {
  return <RoomRow name="Room Name" manifold={manifold} getValue={room => room.name} />;
};
